import _ from "underscore";
import * as config from "../config";
import uuid from "uuid/v1";

const textPadding = function (text, padding, coordinate) {
    let size;
    let currentCoordinate;
    if (coordinate === 'x') {
        size = text.displayWidth;
        currentCoordinate = text.x;
    } else {
        size = text.displayHeight;
        currentCoordinate = text.y;
    }
    return size + currentCoordinate + padding;
};

const hit = (id, bullet, db, scene, group) => {
    let date = new Date();
    let index = _.findIndex(db.items, (element) => {
        return element.id === id;
    });
    if (db.items[index] !== undefined && date >= db.items[index].lastDamageTime
        || db.items[index] !== undefined && !db.items[index].lastDamageTime) {
        date.setMilliseconds(date.getMilliseconds() + 500);
        db.items[index].lastDamageTime = date;
        db.items[index].hp -= scene.character.damage;
        if (db.items[index].hp <= 0) {
            group.remove(db.items[index].item, true, true);
            db.items.splice(index, 1)
        } else {
            let velocity = db.items[index].item.body.velocity.x
            if (bullet.x > db.items[index].item.x) {
                db.items[index].item.setVelocity(-600, -50);
            } else {
                db.items[index].item.setVelocity(+600, -200);
            }
            scene.tweens.add({
                targets: db.items[index].item,
                alpha: {from: 1, to: 0.5},
                onStart: () => {
                    if (db.items[index]) {
                        changeActive(db.items[index].item)
                    }
                },
                onComplete: () => {
                    if (db.items[index]) {
                        changeActive(db.items[index].item, velocity)
                    }
                },
                ease: 'Liner',
                duration: 300,
                repeat: 2,
                yoyo: true
            })
        }
    }
}

const gameStart = () => {
    if (localStorage.getItem('deadline-game')) {
        let gameInfo = JSON.parse(localStorage.getItem('deadline-game'));
        if (gameInfo[gameInfo.length - 1].date_end === null) {
            gameInfo[gameInfo.length - 1] = createNewGame();
        } else {
            gameInfo.push(createNewGame())
            localStorage.setItem('deadline-game', JSON.stringify(gameInfo))
        }
    } else {
        localStorage.setItem('deadline-game', JSON.stringify([createNewGame()]));
    }
}

const gameEnd = (game, config) => {

    let gameInfo = JSON.parse(localStorage.getItem('deadline-game'));
    gameInfo[gameInfo.length - 1].date_end = new Date();
    let date_end = new Date(gameInfo[gameInfo.length - 1].date_end)
    let date_start = new Date(gameInfo[gameInfo.length - 1].date_start)
    gameInfo[gameInfo.length - 1].game_time = date_end.getTime() - date_start.getTime();
    gameInfo[gameInfo.length - 1].projects = config.other.projects.level - 1;
    localStorage.setItem('deadline-game', JSON.stringify(gameInfo));

    config.other.projects.level = 1;
    game.scene.stop('Game')
    game.scene.start('Menu');
}

const getBestTime = () => {
    let gameInfo = JSON.parse(localStorage.getItem('deadline-game'));
    let time = _.max(gameInfo, (element) => {
        return element.game_time
    })
    time = new Date(time.game_time) || 0;
    return `${time.getMinutes()}:${time.getSeconds()}`
}

const getBestProject = () => {
    let gameInfo = JSON.parse(localStorage.getItem('deadline-game'));
    let projects = _.max(gameInfo, (element) => {
        return element.projects
    })
    return projects.projects || 0
}

const createNewGame = () => {
    return {
        id: uuid(),
        date_start: new Date(),
        date_end: null,
        game_time: null,
        projects: 0,
    };
}

export default {
    textPadding,
    hit,
    gameStart,
    gameEnd,
    getBestTime,
    createNewGame,
    getBestProject
}


const changeActive = (item, velocity) => {
    item.isHitted = !item.isHitted;
    if (velocity) {
        item.setVelocityX(velocity)
    }
}
